import {
  resourceReducer,
} from 'redux-resource';
import {
  selection,
  includedResources,
} from 'redux-resource-plugins';

import {
  allListPlugin,
  customListPlugin,
  multiListPlugin,
} from './plugins';

export default resourceReducer('documents', {
  initialState: {
    ...selection.initialState,
  },
  plugins: [
    selection,
    allListPlugin,
    multiListPlugin,
    customListPlugin,
    includedResources,
  ],
});
